import React from 'react';
import classnames from 'classnames';

import { useTranslation } from '@lt/localization';
import { CurrencyFormat, Link } from '@lt/components';
import styles from './nearestDeparturesBlock.module.css';

import type { INearestDeparturesBlock } from './types';

export const NearestDeparturesBlock = (props: INearestDeparturesBlock) => {
  const { departures, isMobile } = props;
  const { t } = useTranslation();

  return (
    <div
      className={classnames(styles.container, {
        [styles.containerMobile]: isMobile,
      })}
    >
      <ul
        className={classnames(styles.list, {
          [styles.listMobile]: isMobile,
        })}
      >
        {departures.map((departure) => {
          const { link, minPrice, nameForm2 } = departure;
          return (
            <li key={nameForm2}>
              {t('explore.hotels.toursFrom', {
                departure: nameForm2,
              })}
              <Link href={link}>
                {` ${t('filters.prices.from')} `}
                <CurrencyFormat value={minPrice} />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
